import { Badge } from '@mantine/core';

export type SellerApplicationStatus =
  | 'DRAFT'
  | 'PENDING_MODERATION'
  | 'APPROVED'
  | 'REJECTED';

const STATUS_LABELS: Record<SellerApplicationStatus, string> = {
  DRAFT: 'Черновик',
  PENDING_MODERATION: 'На модерации',
  APPROVED: 'Одобрена',
  REJECTED: 'Отклонена',
};

const STATUS_COLORS: Record<SellerApplicationStatus, string> = {
  DRAFT: 'gray',
  PENDING_MODERATION: 'yellow',
  APPROVED: 'green',
  REJECTED: 'red',
};

export type SellerApplicationStatusBadgeProps = {
  status: SellerApplicationStatus | null | undefined;
};

export function SellerApplicationStatusBadge({ status }: SellerApplicationStatusBadgeProps) {
  if (!status) return '—';
  return <Badge color={STATUS_COLORS[status]}>{STATUS_LABELS[status]}</Badge>;
}
